export default "__VITE_ASSET__DCPH0Xtp__"